import { FC } from 'react';
import cx from 'classnames';
import { Layout } from 'components/common';

export const ManagementControls: FC = () => (
  <Layout className={cx('content', 'content--with-padding')}>
    Desktop management
  </Layout>
);
